<template>
  <v-list class="py-0" dark v-if="currentGroupType">
    <v-list-group v-for="(group, index) in groups" :key="`${group.GroupName}-${index}`" no-action :sub-group="!isBaseLevel">

      <v-list-tile slot="activator">
        <v-list-tile-action v-if="isBaseLevel">
          <v-icon>{{ getIcon(group) }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-title>{{ group.GroupName }}</v-list-tile-title>
        <v-list-tile-action v-if="!isBaseLevel">
          <v-icon>{{ getIcon(group) }}</v-icon>
        </v-list-tile-action>
      </v-list-tile>

      <v-list-tile ripple v-for="(item, subIndex) in getSortedMonitoringFeatures(group.MonitoringFeatureIds)" :key="`${item.mfId}-${subIndex}`" active-class="activeLink" :to="{name: 'monitoringfeature', params: { monitoringFeatureId: item.mfId }}">
        <v-list-tile-title>{{ item.name }}</v-list-tile-title>
      </v-list-tile>

      <SideMenuGrouper v-if="group.Children" :groups="group.Children" :currentLevel="currentLevel+1" :groupSettings="groupSettings" />
    </v-list-group>
  </v-list>
  <v-list dark v-else>
    <v-list-tile ripple v-for="(item, subIndex) in getSortedMonitoringFeatures(groups)" :key="`${item.mfId}-${subIndex}`" active-class="activeLink" :to="{name: 'monitoringfeature', params: { monitoringFeatureId: item.mfId }}">
      <v-list-tile-action />
      <v-list-tile-title>{{ item.name }}</v-list-tile-title>
    </v-list-tile>
  </v-list>
</template>

<script>
  import {
    groupTypes,
  } from '@/store/UI/navigation'

  import {
    createNamespacedHelpers,
  } from 'vuex'

  const stationHelpers = createNamespacedHelpers('stations')
  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')

  export default {
    name: 'SideMenuGrouper',
    props: {
      currentLevel: {
        type: Number,
        default: 0,
      },
      groups: {
        type: Array,
        default: [],
      },
      groupSettings: {
        type: Object,
        default: () => {},
      },
    },
    computed: {
      ...stationHelpers.mapGetters(['stationCategories', 'mediaTypeList']),
      ...monitoringFeatures.mapGetters([
        'monitoringFeaturesIndex',
        'getDisplayName',
      ]),
      categoryIndex() {
        let index = {}
        if (!this.stationCategories) return index

        this.stationCategories.forEach(sc => index[sc.Name] = sc)
        return index
      },
      mediaTypeIndex() {
        let index = {}
        if (!this.mediaTypeList) return index

        this.mediaTypeList.forEach(mt => index[mt.Name] = mt)
        return index
      },
      isBaseLevel() {
        return this.currentLevel == 0
      },
      currentGroupType() {
        if (!this.groupSettings) return
        return this.groupSettings.GroupType && this.groupSettings.GroupType[this.currentLevel]
      },
    },
    methods: {
      getSortedMonitoringFeatures(monitoringFeatureIds) {
        var that = this
        var data = monitoringFeatureIds.map(mfId => ({
          mfId: mfId,
          name: that.getMonitoringFeatureName(mfId),
        }))
        .sort((a, b) => (a.name > b.name ? 1 : -1))
        return data
      },
      getMonitoringFeatureName(mfId) {
        let monitoringFeature = this.monitoringFeaturesIndex && this.monitoringFeaturesIndex[mfId]

        if (!monitoringFeature) return
        else return this.getDisplayName(monitoringFeature)
      },
      getIcon(group) {
        if (!this.currentGroupType) return

        let key = group.GroupName

        switch (this.currentGroupType) {
        case groupTypes.stationCategory.value: {
          let categoryIcon = this.categoryIndex[key]
          return categoryIcon && categoryIcon.IconPath || 'help'
        }
        case groupTypes.sampleMediaType.value: {
          let mediaIcon = this.mediaTypeIndex[key]
          return mediaIcon && mediaIcon.IconPath || 'help'
        }
        case groupTypes.timeSeriesTag.value: {
          let mediaIcon = this.mediaTypeIndex[key]
          return mediaIcon && mediaIcon.IconPath || 'help'
        }
        case groupTypes.vegetativeCommunityType.value: {
          let mediaIcon = this.mediaTypeIndex[key]
          return mediaIcon && mediaIcon.IconPath || 'help'
        }
        case groupTypes.vegetativePlotType.value: {
          let mediaIcon = this.mediaTypeIndex[key]
          return mediaIcon && mediaIcon.IconPath || 'help'
        }
        case groupTypes.surveyType.value: {
          let mediaIcon = this.mediaTypeIndex[key]
          return mediaIcon && mediaIcon.IconPath || 'help'
        }
        }
      },
    },
  }
</script>